// src/components/SearchCard.jsx
// Clean minimal search result card
// Shows ONLY topic name + small status indicators
// Works the same from Search & Profile topic list

import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/SearchCard.css";
import { buildTopicPath } from "../utils/publicPaths";
import { warmTopicNavigation } from "../api/topicAPI";

function SearchCard({ topic }) {
  const navigate = useNavigate();
  if (!topic) return null;

  // Extract safe fields from topic object
  const {
    id,
    word,          // topic title
    status,        // active / locked / under_review
    locked,        // 1 or 0 from DB
    edit_count,    // number of edits
  } = topic;

  // Status logic
  const isUnderReview = status === "under_review";
  const isLocked =
    locked === 1 || locked === true || status === "locked";

   const openView = () => {
    navigate(buildTopicPath(topic), { state: { topic } });
  };
   
  const warmView = () => {
    warmTopicNavigation(topic);
  };

  return (
     <div
      className={`search-card-row ${isUnderReview ? "under-review" : ""}`}
      onClick={openView}
      onMouseEnter={warmView}
      onFocus={warmView}
    >
      {/* LEFT: Only topic title */}
      <div className="search-card-left">
        <span className="search-card-title">{word}</span>
      </div>

      {/* RIGHT: small badges */}
      <div className="search-card-right">
        {isUnderReview ? (
          <span className="badge badge-under-review">Under Review</span>
        ) : isLocked ? (
          <span className="badge badge-locked">Locked</span>
        ) : (
          <span className="badge badge-active">Active</span>
        )}

        {/* Edit counter */}
        <span className="edit-count">
          Edited: {edit_count ? edit_count : 0}
        </span>
      </div>
    </div>
  );
}

export default SearchCard;
